import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import customers from './customers/index';
import purchaseOrder from "./purchase-order";
import purchaseMark from "@/store/purchase-order/purchase-mark";

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  modules:{
    customers,
    purchaseOrder,
    purchaseMark
  }
})
